var O = Object.defineProperty;
var w = (n, t, e) => t in n ? O(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var o = (n, t, e) => (w(n, typeof t != "symbol" ? t + "" : t, e), e);
class c extends Error {
}
c.prototype.name = "InvalidTokenError";
function _(n) {
  return decodeURIComponent(atob(n).replace(/(.)/g, (t, e) => {
    let s = e.charCodeAt(0).toString(16).toUpperCase();
    return s.length < 2 && (s = "0" + s), "%" + s;
  }));
}
function v(n) {
  let t = n.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return _(t);
  } catch {
    return atob(t);
  }
}
function m(n, t) {
  if (typeof n != "string")
    throw new c("Invalid token specified: must be a string");
  t || (t = {});
  const e = t.header === !0 ? 0 : 1, s = n.split(".")[e];
  if (typeof s != "string")
    throw new c(`Invalid token specified: missing part #${e + 1}`);
  let f;
  try {
    f = v(s);
  } catch (d) {
    throw new c(`Invalid token specified: invalid base64 for part #${e + 1} (${d.message})`);
  }
  try {
    return JSON.parse(f);
  } catch (d) {
    throw new c(`Invalid token specified: invalid json for part #${e + 1} (${d.message})`);
  }
}
const g = "credenza_web_sdk:";
function p(n, t) {
  return localStorage.setItem(`${g}${n}`, t);
}
function I(n) {
  return localStorage.getItem(`${g}${n}`);
}
function b(n) {
  return localStorage.removeItem(`${g}${n}`);
}
const T = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, u = "access_token", k = "login_provider", a = {
  ERROR: "ERROR",
  INIT: "INIT",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
}, r = /* @__PURE__ */ new Map();
let i = 0;
function h(n, t) {
  const e = r.get(n);
  if (e != null && e.length) {
    for (let s = e.length - 1; s >= 0; s--)
      if (e[s].id === t) {
        e.splice(s, 1), r.set(n, e);
        return;
      }
  }
}
function L(n, t) {
  const e = r.get(n) ?? [];
  return i = i + 1, e.push({ callback: t, id: i, once: !0 }), r.set(n, e), () => h(n, i);
}
function S(n, t) {
  const e = r.get(n) ?? [];
  return i = i + 1, e.push({ callback: t, id: i }), r.set(n, e), () => h(n, i);
}
function l(n, t) {
  const e = r.get(n);
  if (e != null && e.length)
    for (const s of e)
      s.callback(t), s.once && h(n, s.id);
}
class E {
  constructor(t) {
    o(this, "clientId");
    o(this, "env");
    o(this, "extensions", []);
    o(this, "oauth");
    o(this, "account");
    o(this, "metamask");
    o(this, "evm");
    o(this, "walletconnect");
    o(this, "sui");
    o(this, "accessToken");
    o(this, "loginProvider");
    o(this, "once", L);
    o(this, "on", S);
    o(this, "_emit", l);
    this.clientId = t.clientId, this.env = t.env || T.PROD;
    for (const e of t.extensions || [])
      Object.assign(this, { [e.name]: e }), this.extensions.push(e.name);
  }
  async initialize() {
    var t;
    if (this.accessToken = I(u), this.loginProvider = I(k), this.accessToken) {
      const e = m(this.accessToken);
      (!e.exp || e.aud !== this.clientId || e.exp * 1e3 < (/* @__PURE__ */ new Date()).getTime()) && this.logout();
    }
    for (const e of this.extensions)
      await ((t = this[e]) == null ? void 0 : t._initialize(this));
    l(a.INIT);
  }
  async _setAccessToken(t, e) {
    p(k, e), p(u, t), this.accessToken = t, this.loginProvider = e, l(a.LOGIN);
  }
  getAccessToken() {
    return this.accessToken;
  }
  getLoginProvider() {
    return this.loginProvider;
  }
  isLoggedIn() {
    return !!this.accessToken && !!this.loginProvider;
  }
  logout() {
    b(u), this.accessToken = null, this.loginProvider = null, l(a.LOGOUT);
  }
}
o(E, "SDK_ENV", T), o(E, "SDK_EVENT", a);
export {
  E as CredenzaSDK
};
